export const heroKeywords = ["Expand", "Resolve", "Streamline"];

export const marqueeItems = [
    { title: "Website Development", path: "/solutions/website-development" },
    { title: "Mobile App Development", path: "/solutions/mobile-app-development" },
    { title: "Digital Marketing", path: "/solutions/digital-marketing" },
    { title: "Video Editing", path: "/solutions/video-editing" },
    { title: "Post Editing", path: "/solutions/post-editing" },
    { title: "HonestiIQ", path: "/software/honesti-crm" },
    { title: "EasyOn", path: "/software/easyon" },
    { title: "WhatsApp Bulk Sender", path: "/software/whatsapp-bulk-sender" },
    { title: "Social Media Automation Software", path: "/software/socialmedia-automation-software" },
    { title: "WhatsApp API Platform", path: "/software/whatsapp-api-platform" },
    { title: "SMS, Call & Email Broadcast", path: "/software/sms-call-email-broadcast" },
];

export type WhyChooseUsIcon = "layers" | "workflow" | "building2" | "handshake";

export const whyChooseUsFeatures: {
    title: string;
    description: string;
    icon: WhyChooseUsIcon;
}[] = [
    {
        title: "End-to-End Digital Solutions",
        description: "Websites, apps, marketing, and content — everything your business needs to establish a powerful online presence.",
        icon: "layers",
    },
    {
        title: "Automation-First Software",
        description: "CRM, WhatsApp, and social media tools designed to eliminate manual work and accelerate growth.",
        icon: "workflow",
    },
    {
        title: "Built for SMEs",
        description: "Practical, affordable technology tailored for small and medium businesses ready to scale digitally.",
        icon: "building2",
    },
    {
        title: "Dedicated Growth Partner",
        description: "From strategy to execution, Honesti stays with you at every stage of your business journey.",
        icon: "handshake",
    },
];

export const stats = [
    { value: 5, suffix: "+", label: "Digital Solutions" },
    { value: 6, suffix: "+", label: "Software Products" },
    { value: 12, suffix: "+", label: "Connected Services" },
    { value: 98, suffix: "%", label: "Client Satisfaction" },
];

export const homeFaqItems = [
    {
        question: "What solutions does Honesti Digital offer?",
        answer: "Honesti Digital provides CRM platforms, business automation software, messaging solutions, digital marketing services, and custom web and mobile application development.",
    },
    {
        question: "Which industries do you serve?",
        answer: "We work with businesses across real estate, education, healthcare, retail, manufacturing, consulting, and other growing industries.",
    },
    {
        question: "Can your software be customized for our business needs?",
        answer: "Yes. Our platforms can be configured and customized to match specific workflows, operational processes, and business requirements.",
    },
    {
        question: "Do you provide implementation, training, and support?",
        answer: "Yes. We assist with onboarding, deployment, user training, and ongoing technical support to ensure successful adoption.",
    },
    {
        question: "Can your solutions integrate with our existing systems?",
        answer: "Yes. Our products can integrate with CRMs, ERP systems, websites, payment gateways, communication platforms, and other third-party tools.",
    },
    {
        question: "How can we get started with Honesti Digital?",
        answer: "Simply contact our team through the website or book a consultation. We will understand your requirements and recommend the most suitable solution.",
    },
];

export const testimonials = [
    {
        quote:
            "Honesti helped us move from manual WhatsApp replies to automated campaigns. Our response time dropped and sales went up within weeks.",
        name: "Priya S.",
        role: "Retail Business Owner, Chennai",
        rating: 5,
    },
    {
        quote:
            "From website launch to CRM setup, Honesti handled our entire digital stack. We finally have one team for every growth stage.",
        name: "Arun K.",
        role: "Founder, IT Services",
        rating: 5,
    },
    {
        quote:
            "Their bulk messaging and social automation tools transformed how we reach customers. Professional, fast, and always supportive.",
        name: "Meena R.",
        role: "Marketing Head, Hospitality",
        rating: 5,
    },
];
